import { createSlice } from '@reduxjs/toolkit';
import { graphqlApi } from '../api'

const userDetailsSlice = createSlice({
  name: 'userDetails',
  initialState: {
    userDetails: [],
  },
  reducers: {
    setUserDetails(state, action) {
      state.userDetails = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      graphqlApi.endpoints.getUserDetails.matchFulfilled,
      (state, { payload }) => {
        state.userDetails = payload;
      }
    )
    builder.addMatcher(
      graphqlApi.endpoints.getUserDetails.matchRejected,
      (state, payload) => {
      },
    )
  },
});

export const { setUserDetails } = userDetailsSlice.actions;

export const selectUserDetails = (state) => {
  return state?.userDetailsSlice?.userDetails?.getUserDetails
}

export default userDetailsSlice.reducer;